<template>
  <v-container>
    <v-row justify="center" no-gutters>
      <v-col class="text-center" cols="12">
        {{ format(new Date(), "YYY") }}
        <strong>{{ $t("Nomad") }}</strong>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "CopyrightComponent",
  data() {
    return {
      format
    };
  }
};
</script>

<style scoped></style>
